import { createFileRoute } from '@tanstack/react-router'
import TenantSettings from '@/components/settings-route/tenant/index.jsx'

export const Route = createFileRoute('/_auth/settings/tenant/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TenantSettings />
}
